<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="copyright"><a id="page_iv"></a>Henry Holt and Company, LLC<br/><em>Publishers since 1866</em><br/>175 Fifth Avenue<br/>New York, New York 10010<br/><a href="http://www.HenryHoltKids.com" target="_blank">www.HenryHoltKids.com</a></p>
<p class="copyright">Henry Holt<sup>®</sup> is a registered trademark of Henry Holt and Company, LLC.<br/>Text copyright © 2009 by Marian Hale</p>
<p class="copyright">All rights reserved.<br/>Distributed in Canada by H. B. Fenn and Company Ltd.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data Hale, Marian.<br/>The goodbye season / Marian Hale.—1st ed.<br/>p.       cm.<br/>Summary: In Canton, Texas, seventeen-year-old Mercy’s dreams of a different life than her mother’s are postponed by harsh circumstances, including the influenza epidemic of 1918–19, which forces her into doing domestic work for a loving, if troubled, family.<br/>ISBN 978-0-8050-8855-7<br/>[1. Coming of age—Fiction. 2. Family life—Texas—Fiction. 3. Household<br/>employees—Fiction. <span class="small">4</span>. Mothers and daughters—Fiction. 5. Grief—Fiction.<br/>6. Texas—History—1846–1950—Fiction.] I. Title.<br/>PZ7.H1373Goo 2009 [Fic]—dc22 2008050275</p>
<p class="copyright">First Edition—2009<br/>Printed in the United States of America on acid-free paper.∞</p>
<p class="copyright">1 3 5 7 9 10 8 6 4 2</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?482ecbf6